<template>
  <a-modal
    :visible="visible"
    title="从素材库选择图片"
    :width="960"
    :maskClosable="false"
    :footer="null"
    @cancel="handleClose">
    <a-spin :spinning="false">
      <!-- 选择模式网格：selectable=true，选中集由 selection-change 上抛 -->
      <media-grid
        ref="grid"
        :selectable="true"
        :multiple="multiple"
        :limit="limit"
        @pick="onPickSingle"
        @selection-change="onSelectionChange" />
      <!-- 底部确认栏（单选点击图片直接确认，无需按钮） -->
      <div v-if="multiple" class="picker-footer">
        <a-button style="margin-right: 12px" @click="handleClose">取消</a-button>
        <a-button type="primary" :disabled="!selectedItems.length" @click="confirmSelect">
          确认选择 {{ selectedItems.length ? selectedItems.length + ' ' : '' }}项
        </a-button>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import MediaGrid from './MediaGrid'

/**
 * 统一素材选择器弹窗（所有媒体页接入：业务页只存 url）
 * 用法：<media-picker-modal ref="picker" :multiple="true" @ok="onPicked" />
 *       this.$refs.picker.open() → ok 回调收 items:[{id,url,name}]，业务页只取 item.url 入库
 * props：multiple 默认 true（false 时单选，点击图片直接确认返回）；limit 多选上限（0 不限）
 */
export default {
  name: 'MediaPickerModal',
  components: { MediaGrid },
  props: {
    multiple: { type: Boolean, default: true },
    limit: { type: Number, default: 0 }
  },
  data() {
    return {
      visible: false,
      hasLoaded: false,
      selectedItems: []
    }
  },
  methods: {
    open() {
      this.selectedItems = []
      this.visible = true
      // 首次打开时 MediaGrid created 自动加载；此后重开刷新数据并清空选中
      this.$nextTick(() => {
        if (this.$refs.grid) {
          if (this.hasLoaded) {
            this.$refs.grid.reload()
          } else {
            this.hasLoaded = true
          }
        }
      })
    },
    onPickSingle(item) {
      // 单选：点击图片直接确认
      this.$emit('ok', [item])
      this.handleClose()
    },
    onSelectionChange(items) {
      this.selectedItems = items
    },
    confirmSelect() {
      if (!this.selectedItems.length) {
        return
      }
      this.$emit('ok', this.selectedItems)
      this.handleClose()
    },
    handleClose() {
      this.visible = false
      this.selectedItems = []
    }
  }
}
</script>

<style scoped>
.picker-footer {
  text-align: right;
  border-top: 1px solid #e8e8e8;
  padding-top: 12px;
  margin-top: 12px;
}
</style>
